import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { api } from "../../../utlis/admin/api.utlis";
import Loader from "../../../layouts/loader/Loader";
import ApiService from "../../../core/services/ApiService";
import WhCalen from "../../../assets/user/images/whcalendar.svg";
import RepeatImg from "../../../assets/user/images/Repeat.svg";
import { decode } from "base-64";
import { status, weekDays } from "../../../utlis/common.utlis";
import moment from "moment";
import { encode } from "base-64";
import locationImage from "../../../assets/admin/images/Google_Map.svg";
import NoImage from "../../../assets/admin/images/no-image.jpg";
import { routes } from "../../../utlis/admin/routes.utlis";
import Face1 from "../../../assets/admin/images/face1.jpg";

const Details = () => {
  const navigate = useNavigate();
  const [details, setDetails] = useState();
  const [loading, setLoading] = useState(false);
  const localData = useLocation();
  const id = localData.state?.id;

  const getJobDetails = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    if (response.data.status && response.data.statusCode === 200) {
      setDetails(response.data.data);
    } else setDetails();
    setLoading(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getJobDetails(api.careJobDetails + `${decode(id)}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      {loading ? <Loader /> : null}
      <div className="content-wrapper">
        <div className="page-header">
          <h3 className="page-title">
            <Link
              className="btn-back"
              to=""
              onClick={(e) => {
                e.preventDefault();
                navigate(-1);
              }}
            >
              <i className="mdi mdi-arrow-left-thin"></i>
            </Link>
            Care Assessment Details
          </h3>
        </div>
        <div className="row">
          <div className="col-md-12 mb-3">
            <div className="care-card mb-0">
              <div className="care-card-head">
                <div className="care-id">
                  Job ID: <span>{details?.job_id ?? "NA"}</span>
                </div>

                <div className="care-status">
                  {
                    <div>
                      Status: <span>{details?.request_status ?? "NA"}</span>
                    </div>
                  }
                </div>
              </div>
              <div className="care-card-body">
                <div className="care-content">
                  <div className="title-text">{details?.first_name ?? "NA"}</div>
                  <div className="d-flex justify-content-between">
                    <div className="d-flex">
                      <div className="date-text">
                        <img src={WhCalen} />{" "}
                        {moment(details?.start_date).format("MM-DD-yyyy")}{" "}
                        {details?.start_time ?? "NA"}
                      </div>
                      <div className="pointtags-list mx-2">
                        <div className="tags-item1">
                          {details?.category ?? "NA"}
                        </div>
                        <div className="tags-item-sub1">
                          {details?.subcategory ?? "NA"}
                        </div>
                      </div>
                    </div>
                    <div className="tags-list float-end">
                      <div className="tags-item-sub">
                        {details?.gender == "M" ? "Male" : "Female"}
                      </div>
                      <div className="tags-item-sub mx-2">
                        Age of who needs care: {details?.age ?? "NA"} Years
                      </div>
                    </div>
                  </div>
                  <div className="care-point-list1">
                    <div className="row">
                      <div className="col-md-3">
                        <div className="jobs-details-point-item">
                          <h4>Email Id: </h4>
                          <p className="text-lowercase">
                            {details?.email_id ?? "NA"}
                          </p>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="jobs-details-point-item">
                          <h4>Contact phone number of who needs care: </h4>
                          <p className="text-capitalize">
                            {(details?.fax != "" && details?.fax != null && details?.fax != undefined )? details?.fax : "NA"}
                          </p>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="care-point-box">
                          <div className="care-point-icon">
                            <img src={RepeatImg} />
                          </div>
                          <div className="care-point-text">
                            <h4>Frequency: </h4>
                            <p style={{ height: "25px" }}>
                              {details?.frequency === "O"
                                ? "One Time"
                                : details?.frequency === "W"
                                ? "Repeat Weekly"
                                : "Repeat Monthly"}
                            </p>
                            <div className="care-day-list">
                              {details?.days !== null &&
                              details?.days !== "" &&
                              details?.days !== undefined
                                ? JSON.parse(details?.days).map(
                                    (element, index) => {
                                      return (
                                        <div
                                          key={index}
                                          className="tags-item-sub me-1"
                                        >
                                          {weekDays(element)}
                                        </div>
                                      );
                                    }
                                  )
                                : null}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="care-point-box">
                          <div className="care-point-text">
                            <h4>Prefered Contact: </h4>
                            <p className="text-capitalize">
                              {details?.prefer_contacted ?? "NA"}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="care-point-box">
                          <div className="care-point-text">
                            <h4>Payment Type: </h4>
                            <p className="text-capitalize">
                              {details?.payment_type ?? "NA"}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-12 mb-3">
            <div className="jobs-details-info-card mb-0">
              <div className="jobs-details-phone">{details?.phone ?? "NA"}</div>

              <div className="jobs-details-point">
                <div className="jobs-details-point-item">
                  <h4>Best Time To Call: </h4>
                  <p className="text-capitalize">
                    {details?.best_time_to_call ?? "NA"}
                  </p>
                </div>
                <div className="jobs-details-point-item">
                  <h4>Your Relationship To Who Needs Care: </h4>
                  <p>{details?.relationship ?? "NA"}</p>
                </div>
                <div className="jobsdetails-location-item">
                  <div className="jobsdetails-location-item-icon">
                    <img src={locationImage} />
                  </div>
                  <div className="jobsdetails-location-item-text">
                    <h4>Address of Client or Person That Needs Care:</h4>
                    <p>{details?.address ?? "NA"}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-12 mb-3">
            <div className="jobs-details-desc-card mb-0">
              <h3>Description Of Care Needed</h3>
              <p>{details?.description ?? "NA"}</p>
            </div>
          </div>

          {details?.providers?.length !== 0
            ? details?.providers?.map((ele, indx) => {
                return (
                  <div className="col-md-6" key={indx}>
                    <div className="care-bob-user-card">
                      <div className="care-bob-user-card-box">
                        <div className="care-bob-user-card-image">
                          {ele.image === null ||
                          ele.image === "" ||
                          ele.image === undefined ? (
                            <img src={NoImage} className="me-3" alt="" />
                          ) : (
                            <img src={ele.image} className="me-3" alt="" />
                          )}
                        </div>
                        <div className="care-bob-user-card-content">
                          <h5 className="">{ele.fullname ?? "NA"}</h5>
                          <p className="m-0">
                            <i className="mdi mdi-checkbox-multiple-marked-circle-outline"></i>{" "}
                            {ele.provider_status} Care Provider
                          </p>
                        </div>
                      </div>
                      <div className="care-bob-user-card-box">
                        <button
                          type="button"
                          className="btn-gr"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate(routes.providerDetails, {
                              state: {
                                id: encode(ele.provider_id),
                              },
                            });
                          }}
                        >
                          View Profile
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })
            : null}
        </div>
      </div>
    </>
  );
};

export default Details;
